var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPelintex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 132.86 34.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#56635f;stroke:#56635f;stroke-width:.3px;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M70.06 58.07H57.65V41h12.41v1.44h-10.8v6.4h8l-.78 1.44h-7.22v6.32h10.8Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M86.46 58.07H74.72V41h1.62v15.6h10.12Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M91.85 58.07h-1.61V41h1.61Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M112.42 58.12H111L99 43.75v14.37h-1.65V41.05h1.4v.06l12 14.36V41.05h1.61Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M124.4 58.07h-1.61V42.44H116V41h15.2v1.44h-6.8Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M147.22 58.07h-12.41V41h12.41v1.44h-10.8v6.4h8.63l-.78 1.44h-7.85v6.32h10.8Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M42.07 58.07h-1.61V41h6.13c4.1 0 6.86 2.25 6.86 5.6s-2.81 5.68-7 5.68h-2.64v-1.45h2.75c3.16 0 5.28-1.7 5.28-4.23s-2.12-4.16-5.28-4.16h-4.49Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M38.74 52.23h-4.28l.7-1.3h3.58Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M166.34 58.07 151.81 41h-2.08l7.37 8.61-7.31 8.46h2l6.36-7.24 6.19 7.24Z",
    className: "cls-1",
    transform: "translate(-34.21 -40.85)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "polygon26",
    d: "m126.02 7.5 6.16-7.35h-2.07l-5.14 6.13 1.05 1.22z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text42",
    style: {
      fontSize: "8.65px",
      fill: "#a9bfb6",
      stroke: "#a9bfb6",
      strokeWidth: ".15px",
      fontFamily: "Campton-Book,Campton",
      letterSpacing: ".03em",
      strokeMiterlimit: 10
    },
    transform: "translate(84.58 26.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan49",
    style: {
      letterSpacing: ".35px",
      InkscapeFontSpecification: "&quot",
      fontFamily: "sans-serif",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      fontVariant: "normal",
      fontSize: "8.65000025px",
      textAnchor: "start",
      textAlign: "start",
      writingMode: "lr",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal"
    }
  }, "BULGARIA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPelintex);
export default __webpack_public_path__ + "static/media/pelintex.dd26d70995a343a927122f0db629d64d.svg";
export { ForwardRef as ReactComponent };